var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xy-center flex-y",staticStyle:{"width":"100%","height":"100%"}},[_c('img',{staticStyle:{"width":"196px","height":"214px"},attrs:{"src":"https://oss.yf-gz.cn/file/1706595875413_73b20fec9b0d6a02c51ee4758fa48e22.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"empty-text"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4990800a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/zzcbpmDashboard/common/empty.vue
// module id = null
// module chunks = 